import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from "@ngrx/store";
import {CoreState} from "@core/store/core.reducers";
import {CoreSelectors} from "@core/store/core.selectors";
import {environment} from "@env";

@Injectable({
  providedIn: 'root'
})
export class IsOfflineGuard implements CanLoad, CanActivate {

  constructor(
    private store: Store<CoreState>
  ) {
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(!environment.production){
      return true
    }

    return this.store.select(CoreSelectors.isOffline)

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(!environment.production){
      return true
    }

    return this.store.select(CoreSelectors.isOffline)
  }
}
